import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { getWidthStyle } from '../utils/sizing';
import { genericEmbedContainer } from './GenericEmbed.css';
import type {
  GenericEmbedDescriptionElementProps,
  GenericEmbedElementProps,
  GenericEmbedHostElementProps,
  GenericEmbedTitleElementProps,
} from './GenericEmbed.type';

export const GenericEmbedElement = (props: GenericEmbedElementProps) => {
  const { element, children } = props;
  const { id, variant, width, width_max } = element.attrs || {};

  return (
    <div
      id={id}
      className={classNames('generic-embed flex border rounded-md p-4', genericEmbedContainer, {
        'flex-row-reverse': variant === 'text-left-image-right',
      })}
      style={
        {
          '--width': getWidthStyle(width, width_max).width,
          '--max-width': getWidthStyle(width, width_max).maxWidth,
        } as CSSProperties
      }
    >
      <div>
        <div className="w-40">{/* Image component */}</div>
      </div>
      <div className="whitespace-pre-wrap grow">{children}</div>
    </div>
  );
};

export const GenericEmbedTitleElement = (props: GenericEmbedTitleElementProps) => {
  const { element, children } = props;
  const { id } = element.attrs || {};

  return (
    <h3 id={id} className="generic-embed-title mb-2 text-xl font-bold">
      {children}
    </h3>
  );
};

export const GenericEmbedDescriptionElement = (props: GenericEmbedDescriptionElementProps) => {
  const { element, children } = props;
  const { id } = element.attrs || {};

  return (
    <div id={id} className="generic-embed-description">
      {children}
    </div>
  );
};

export const GenericEmbedHostElement = (props: GenericEmbedHostElementProps) => {
  const { element, children } = props;
  const { id } = element.attrs || {};

  return (
    <div id={id} className="generic-embed-host text-xs break-all mt-4">
      {children}
    </div>
  );
};
